module.exports = __webpack_public_path__ + "static/WEDDING E&M-439-96214a8d0299989d80bab59c022cbfbd.jpg";